export default {
  data () {
    return {
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1
    }
  }
}
